@if (alert().isVisible) {
  <div
    [@fadeSlide]
    class="fixed left-1/2 bottom-4 transform -translate-x-1/2 z-[9999999] flex gap-1 px-4 py-3 w-1/3 text-sm mx-auto"
    [class]="cssAlerts[alert().type]"
  >
    <lucide-angular name="check-circle" [class]="'h-4'"></lucide-angular> {{ alert().message }}
  </div>
}
